import { addGETParams } from '../../config'
import ax from '../api'

/*
 * getFullItm - Get a compact list of items from the server, such as sprints, categories, etc.
 * @param {string} targetLst - The target list to get from the server
 * @param {string} controlerId - Id of the user that has permission to view or controll specific list items
 * @param {object} params - Additional parameters to send to the server
 * @returns {object} The response from the server
 */
export const getFullItm = async (targetLst, params) => {
	const _url = addGETParams(`/full/get.php?lst=${targetLst}`, params)

	const { data } = await ax.get(_url)
	return data
}

export const getModifiedItm = async (targetLst, params) => {
	const _url = addGETParams(`/modified/get.php?lst=${targetLst}`, params)

	const { data } = await ax.get(_url)
	return data
}

export const getItemCounts = async (targetLst) => {
	const _url = addGETParams(`/itemCounts/get.php?lst=${targetLst}`)

	const { data } = await ax.get(_url)
	return data
}
